import React, { Fragment } from "react";
import "./drop.css";

const DropDown = ({ onclickHandler, data, style }) => {
  if (data) {
    return (
      <div className="dropdown">
        <div
          className="dropdown-toggle"
          id="menu1"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fa fa-bars fs_size" />
        </div>
        <ul
          className=" drop_menu_align dropdown-menu"
          role="menu"
          aria-labelledby="menu1"
          style={style}
        >
          <Fragment>
            {data.map((d, i) => {
              return (
                <Fragment key={i}>
                  <li role="presentation">
                    <a role="menuitem" name={d.name} onClick={onclickHandler}>
                      {d.icon ? <i className={`fa ${d.icon}`} /> : null}
                      {d.text}
                    </a>
                  </li>
                  <li role="presentation" className="divider" />
                </Fragment>
              );
            })}
          </Fragment>
        </ul>
      </div>
    );
  } else {
    return null;
  }
};

export default DropDown;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/common/dropDown/dropDown.jsx